(()=>{
'use strict';
const dialog=document.getElementById('JuyumeFavorites');
if(!dialog)return;
const grid=dialog.querySelector('[data-favorites-grid]');
const empty=dialog.querySelector('[data-favorites-empty]');
const status=dialog.querySelector('[data-favorites-status]');
const storageKey='juyume:favorites:v1';
let trigger=null;
const validUrl=(value,sameOrigin=false)=>{try{const url=new URL(value,location.origin);return (url.protocol==='https:'||url.protocol==='http:')&&(!sameOrigin||url.origin===location.origin)?url.href:null}catch{return null}};
const read=()=>{try{const value=JSON.parse(localStorage.getItem(storageKey)||'{}');return Object.fromEntries(Object.entries(value).filter(([id,item])=>/^\d+$/.test(id)&&item&&typeof item.title==='string'&&validUrl(item.url,true)).slice(-200))}catch{return {}}};
let saved=read();
const sync=()=>{
document.querySelectorAll('[data-product-save]').forEach(button=>{const active=Object.hasOwn(saved,button.dataset.productSave);button.setAttribute('aria-pressed',String(active));button.setAttribute('aria-label',active?button.dataset.removeLabel:button.dataset.saveLabel)});
document.querySelectorAll('[data-favorites-count]').forEach(node=>{const label=Object.keys(saved).length?'('+Object.keys(saved).length+')':'';if(node.textContent!==label)node.textContent=label});
};
const render=()=>{
grid.replaceChildren();
const items=Object.entries(saved).reverse();
empty.hidden=items.length>0;
for(const [id,item] of items){
const card=document.createElement('article');card.className='product-card';
const visual=document.createElement('div');visual.className='product-card__visual';
const link=document.createElement('a');link.className='product-card__media';link.href=validUrl(item.url,true);link.setAttribute('aria-label',item.title);
const source=validUrl(item.image||'');
if(source){const image=document.createElement('img');image.className='product-card__img';image.src=source;image.alt=item.title;image.loading='lazy';link.append(image)}
const button=document.createElement('button');button.type='button';button.className='product-save';button.textContent='♡';
Object.assign(button.dataset,{productSave:id,productUrl:item.url,productTitle:item.title,productPrice:item.price||'',productImage:item.image||'',saveLabel:item.saveLabel||item.title,removeLabel:item.removeLabel||item.title});
button.setAttribute('aria-pressed','true');button.setAttribute('aria-label',item.removeLabel||item.title);
visual.append(link,button);
const info=document.createElement('div');info.className='product-card__info';
const title=document.createElement('a');title.className='product-card__title';title.href=link.href;title.textContent=item.title;
const price=document.createElement('div');price.className='product-card__price';price.textContent=item.price||'';
info.append(title,price);card.append(visual,info);grid.append(card);
}
};
document.addEventListener('click',event=>{
const button=event.target.closest('[data-product-save]');
if(button){
const id=button.dataset.productSave;if(!/^\d+$/.test(id))return;
const wasSaved=Object.hasOwn(saved,id);const next={...saved};
if(wasSaved)delete next[id];else{
if(!validUrl(button.dataset.productUrl,true))return;
next[id]={url:button.dataset.productUrl,title:button.dataset.productTitle,price:button.dataset.productPrice,image:button.dataset.productImage,saveLabel:button.dataset.saveLabel,removeLabel:button.dataset.removeLabel};
const ids=Object.keys(next);if(ids.length>200)delete next[ids[0]];
}
try{localStorage.setItem(storageKey,JSON.stringify(next));saved=next;sync();if(dialog.open)render();status.textContent=wasSaved?status.dataset.removedMessage:status.dataset.savedMessage}
catch{status.textContent=status.dataset.storageError;const toast=document.getElementById('JuyumeToast');if(toast){toast.textContent=status.dataset.storageError;toast.classList.add('is-visible');setTimeout(()=>toast.classList.remove('is-visible'),3200)}}
return;
}
const opener=event.target.closest('[data-favorites-open]');
if(opener){trigger=opener;render();dialog.showModal()}
if(event.target.closest('[data-favorites-close]'))dialog.close();
});
dialog.addEventListener('close',()=>trigger?.focus());
dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close()}});
window.addEventListener('storage',event=>{if(event.key===storageKey){saved=read();sync();if(dialog.open)render()}});
const main=document.getElementById('MainContent');if(main)new MutationObserver(sync).observe(main,{childList:true,subtree:true});
document.querySelector('[data-filter-toggle]')?.addEventListener('click',event=>event.currentTarget.setAttribute('aria-expanded',String(document.getElementById('CollectionSidebar')?.classList.contains('is-visible'))));
sync();
})();
